module.exports = __webpack_public_path__ + "static/assets/c95cae1f73cd15abf8a9381ddab9f201.svg";